import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
  gql,
} from '@apollo/react-hooks';

export const useCreateHoDDoSAssessment = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [createHoDDoSAssessment] = useMutation(gql`
    mutation ($applicationId: ID!) {
      createHodDosAssessment(applicationId: $applicationId) {
        applicationId
      }
    }
  `);
  return createHoDDoSAssessment;
};
